<template>
  <list-template :class="'height__100vh'">
    <template #header>
      <main-header>
        <template #filterByStatus>
          <div
            class="header-title wrapper-content__main font-size__large font-weight__bold"
          >
            Danh mục đánh giá nhân viên
          </div>
        </template>
      </main-header>
    </template>
    <template #view>
      <div class="view">
        <list-template :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <sub-header>
              <template #content>
                <div class="leftSection">
                  <el-button
                    size="medium"
                    type="success"
                    class="createNew"
                    @click="isOpenDialog = true"
                    v-if="isCanUpdate"
                  >
                    <div class="flex-row flex__center">
                      <i class="fas fa-plus-circle font-size__large"></i>
                      <span>&nbsp;&nbsp;THÊM MỚI</span>
                    </div>
                  </el-button>
                </div>
                <div class="flex-row flex__right">
                  <search
                    :keyword="searchForm.keyword"
                    @simpleSearch="simpleSearch"
                    @search="isOpenAdvanceSearchDialog = true"
                  >
                    <template #quickFilter>
                      <el-row :gutter="24">
                        <el-col :span="14">
                          <el-select
                            class="style-fullWidth input-border__bottom input-border__radius__0"
                            v-model="searchForm.deptId"
                            placeholder="-"
                            size="large"
                            @change="deptIdChanged"
                          >
                            <el-option
                              v-for="item in departments"
                              :key="item.id"
                              :label="item.deptName"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-col>
                        <el-col :span="10">
                          <el-date-picker
                            v-model="dateRange"
                            type="daterange"
                            format="dd/MM/yyyy"
                            class="style-fullWidth  input-border__bottom input-border__radius__0"
                            :picker-options="dateQuickFilterOption"
                            range-separator="_"
                            start-placeholder="_"
                            end-placeholder="_"
                            align="right"
                            :clearable="false"
                            size="large"
                            @change="dateRangeChanged"
                          ></el-date-picker>
                        </el-col>
                      </el-row>
                    </template>
                    <template #advance>
                      <ranking-score-advance-search-dialog
                        :isOpen="isOpenAdvanceSearchDialog"
                        :form="searchForm"
                        v-if="isEnableAdvanceSearchDialog"
                        @closed="isEnableAdvanceSearchDialog = false"
                        @closeDialog="isOpenAdvanceSearchDialog = false"
                        @doSearch="advanceSearch"
                      />
                    </template>
                  </search>
                </div>
              </template>
            </sub-header>
          </template>
          <template #body>
            <div class="list">
              <!-- header-title -->
              <div class="header-title flex-row flex__between margin-bottom-10">
                <div class="leftSection flex-row flex__left">
                  <div class="theTitle theTitle__lv5">
                    <span class="stt padding-left-10">STT</span>
                  </div>
                  <!--                  <div-->
                  <!--                    class="theTitle theTitle__lv2 flex-row flex__left clickable"-->
                  <!--                    @click="doSort('rankingReasonName')"-->
                  <!--                  >-->
                  <!--                    Lý do-->
                  <!--                    <sort-caret-->
                  <!--                      :order="pageable.order"-->
                  <!--                      :sort="pageable.sort"-->
                  <!--                      :field="'rankingReasonName'"-->
                  <!--                    />-->
                  <!--                  </div>-->

                  <div
                    class="theTitle theTitle__lv1 flex-row flex__left clickable"
                  >
                    Mô tả
                  </div>
                </div>
                <div class="rightSection flex-row flex__left">
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__left padding-left-10 clickable"
                    @click="doSort('updatorName')"
                  >
                    Người đánh giá
                    <sort-caret
                      :order="pageable.order"
                      :sort="pageable.sort"
                      :field="'updatorName'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__left padding-left-10 clickable"
                    @click="doSort('userFullName')"
                  >
                    Nhân sự
                    <sort-caret
                      :order="pageable.order"
                      :sort="pageable.sort"
                      :field="'userFullName'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__right padding-left-10 clickable"
                    @click="doSort('checkDate')"
                  >
                    Ngày đánh giá
                    <sort-caret
                      :order="pageable.order"
                      :sort="pageable.sort"
                      :field="'checkDate'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__right padding-left-10 clickable"
                    @click="doSort('finalScore')"
                  >
                    Điểm
                    <sort-caret
                      :order="pageable.order"
                      :sort="pageable.sort"
                      :field="'finalScore'"
                    />
                  </div>
                </div>
              </div>
              <!-- list-docs -->
              <vue-perfect-scrollbar
                class="scroll-area"
                :settings="perfectScrollbarSetting"
                infinite-wrapper
              >
                <div class="list-docs">
                  <div
                    v-for="(item, $itemIndex) in items"
                    v-bind:key="$itemIndex"
                    class="item flex-row flex__between"
                    @click="viewDetail(item)"
                  >
                    <div class="leftSection flex-row flex__left">
                      <div class="theTitle__lv5">
                        <div class="flex-row flex__left">
                          <div class="section-check">
                            <span class="stt flex-row flex__center">{{
                                $itemIndex + 1
                              }}</span>
                          </div>
                        </div>
                      </div>
                      <!--                      <div class="theTitle__lv2">-->
                      <!--                        <div class="title-docs flex-col flex__left">-->
                      <!--                          <div class="tt_1 clickable">-->
                      <!--                            {{ item.rankingReasonName }}-->
                      <!--                          </div>-->
                      <!--                          <div class="tt_2 flex-row flex__left margin-top-10">-->
                      <!--                            <el-tag size="mini" :class="['priority', 'lv3']"-->
                      <!--                            >{{ getTypeLabel(item.type) }}-->
                      <!--                            </el-tag>-->
                      <!--                            <el-tag size="mini" :class="['priority', 'lv3']"-->
                      <!--                            >{{ getScoreTypeLabel(item.scoreType) }}-->
                      <!--                            </el-tag>-->
                      <!--                          </div>-->
                      <!--                        </div>-->
                      <!--                      </div>-->
                      <div class="theTitle__lv1">
                        <div class="title-docs flex-col flex__left">
                          <div class="tt_1 clickable">
                            {{ item.note }}
                          </div>
                          <div class="tt_2 flex-row flex__left margin-top-10">
                            <el-tag
                              :type="
                                item.type === RANKING_REASON.TYPE.CONGDIEM
                                  ? 'success'
                                  : 'danger'
                              "
                              class="margin-right-5"
                              size="mini"
                            >{{ getTypeLabel(item.type) }}
                            </el-tag>
                            <el-tag size="mini" class="margin-right-5"
                            >{{ getScoreTypeLabel(item.scoreType) }}
                            </el-tag>
                            <el-tag
                              v-if="!!item.rankingReasonName"
                              size="mini"
                              class="margin-right-5"
                            >{{ item.rankingReasonName }}
                            </el-tag>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rightSection flex-row flex__right">
                      <div
                        class="theTitle__lv3 flex-row flex__left padding-left-10 font-size__small"
                      >
                        <div class="flex-row flex__right">
                          {{ item.updatorName }}
                        </div>
                      </div>
                      <div
                        class="theTitle__lv3 flex-row flex__left padding-left-10 font-size__small"
                      >
                        <div class="flex-row flex__right">
                          {{ item.userFullName }}
                        </div>
                      </div>
                      <div
                        class="theTitle__lv3 flex-row flex__right padding-left-10 font-size__small"
                      >
                        <div class="flex-row flex__left">
                          {{
                            item.checkDate
                              | dateFormatter({dateFormat: "DD/MM/YYYY"})
                          }}
                        </div>
                      </div>
                      <div
                        class="theTitle__lv3 flex-row flex__right padding-left-10 font-size__small"
                      >
                        <div class="flex-row flex__right">
                          <el-tag
                            :type="item.finalScore > 0 ? 'success' : 'danger'"
                          >{{ item.finalScore }}
                          </el-tag>
                        </div>
                      </div>
                    </div>
                  </div>
                  <infinite-loading
                    ref="infiniteLoading"
                    spinner="spiral"
                    @infinite="infiniteHandler"
                  >
                    <div slot="no-more"></div>
                    <div slot="no-results">Không tìm thấy kết quả nào</div>
                  </infinite-loading>
                </div>
              </vue-perfect-scrollbar>
            </div>
          </template>
        </list-template>
      </div>
      <ranking-score-create-dialog
        :isOpen="isOpenDialog"
        :id="selectedId"
        v-if="isEnableDialog"
        @closed="isEnableDialog = false"
        @closeDialog="isOpenDialog = false"
        @insertSuccess="insertSuccess"
        @updateSuccess="updateSuccess"
        @deleteSuccess="deleteSuccess"
      >
      </ranking-score-create-dialog>
    </template>
  </list-template>
</template>

<script>
import ListTemplate from "../common/list";
import MainHeader from "../../components/header/main-header";
import SubHeader from "../../components/main/sub-header";
import Search from "../common/search";
import utils from "../../services/utils";
import departmentService from "../../services/departmentService";
import constants from "../../constants";
import SortCaret from "../doc-out/SortCaret";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import rankingUtils from "../../services/rankingUtils";
import rankingScoreViewService from "../../services/rankingScoreViewService";
import dateUtils from "../../dateUtils";
import RankingScoreCreateDialog from "./ranking-score-create-dialog";
import dateFormatter from "../../filters/dateFormatter";
import RankingScoreAdvanceSearchDialog from "./ranking-score-advance-search-dialog";
import menuConfigService from "../../services/menuConfigService";

export default {
  name: "ranking-reason-index",
  components: {
    RankingScoreAdvanceSearchDialog,
    RankingScoreCreateDialog,
    SortCaret,
    Search,
    SubHeader,
    MainHeader,
    ListTemplate,
    VuePerfectScrollbar
  },
  filters: {dateFormatter},
  data() {
    return {
      pageable: {
        page: 0,
        size: 10,
        sort: "updateTime",
        order: "desc"
      },
      items: [],
      searchForm: {
        deptId: null,
        keyword: null,
        type: null,
        scoreType: null,
        userDeptRoleId: null,
        rankingReasonId: null,
        fromDate: null,
        toDate: null
      },
      departments: [],
      isOpenDialog: false,
      isEnableDialog: false,
      selectedId: null,
      dateRange: null,
      dateQuickFilterOption: null,
      RANKING_REASON: constants.RANKING_REASON,
      perfectScrollbarSetting: {maxScrollbarLength: 350},
      isOpenAdvanceSearchDialog: false,
      isEnableAdvanceSearchDialog: false,
      isCanUpdate: false
    };
  },

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },

    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    }
  },

  watch: {
    isOpenDialog(newValue) {
      newValue ? (this.isEnableDialog = newValue) : (this.selectedId = null);
    },

    isOpenAdvanceSearchDialog(newValue) {
      newValue && (this.isEnableAdvanceSearchDialog = newValue);
    }
  },

  created() {
    if (!this.userDeptRole) return;
    this.loadAccessRight();
    this.initDateQuickFilterOption();
    this.initQuery();
    this.loadDepartments();
  },

  methods: {
    loadAccessRight() {
      return menuConfigService
        .isEnableMenu(
          this.userDeptRoleId,
          constants.MENU_LIST.CONGVIEC_SCORE_UPDATE
        )
        .then(isEnable => (this.isCanUpdate = isEnable));
    },

    dateRangeChanged() {
      this.searchForm.fromDate =
        this.dateRange && this.dateRange[0]
          ? this.dateRange[0].getTime()
          : undefined;
      this.searchForm.toDate =
        this.dateRange && this.dateRange[1]
          ? this.dateRange[1].getTime()
          : undefined;
      this.initDateRange();
      this.doSearch();
    },

    initDateQuickFilterOption() {
      this.dateQuickFilterOption = {
        shortcuts: [
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.THIS_MONTH
          ),
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.LAST_MONTH
          ),
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.NAM_NAY
          )
        ]
      };
    },

    viewDetail(item) {
      this.selectedId = item.id;
      this.isOpenDialog = true;
    },

    insertSuccess() {
      this.isOpenDialog = false;
      this.doSearch();
    },

    updateSuccess() {
      this.isOpenDialog = false;
      this.doSearch();
    },

    deleteSuccess() {
      this.isOpenDialog = false;
      this.doSearch();
    },

    getTypeLabel(type) {
      return rankingUtils.getTypeLabel(type);
    },

    getScoreTypeLabel(type) {
      return rankingUtils.getScoreTypeLabel(type);
    },

    deptIdChanged() {
      this.doSearch();
    },

    loadDepartments() {
      return departmentService
        .findAllCurrentAndIncludeSubDepts()
        .then(response => (this.departments = response.data));
    },

    initQuery() {
      let deptId = this.$route.query.deptId || this.userDeptRole.deptId;
      this.searchForm = {
        deptId: deptId,
        userDeptRoleId: this.$route.query.userDeptRoleId || undefined,
        rankingReasonId: this.$route.query.rankingReasonId || undefined,
        keyword: this.$route.query.keyword || undefined,
        type: this.$route.query.type || undefined,
        scoreType: this.$route.query.scoreType || undefined,
        fromDate: this.$route.query.fromDate
          ? parseInt(this.$route.query.fromDate)
          : undefined,
        toDate: this.$route.query.toDate
          ? parseInt(this.$route.query.toDate)
          : undefined
      };
      this.initDateRange();
    },

    initDateRange() {
      if (this.searchForm.fromDate && this.searchForm.toDate) {
        this.dateRange = [
          dateUtils.toMoment(this.searchForm.fromDate),
          dateUtils.toMoment(this.searchForm.toDate)
        ];
      } else {
        this.dateRange = dateUtils.getDatesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2
        );
        let defaultTimeRange = dateUtils.getTimesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2
        );
        this.searchForm.fromDate = defaultTimeRange[0];
        this.searchForm.toDate = defaultTimeRange[1];
      }
    },

    buildQuery() {
      return utils.merge(
        {sort: this.pageable.sort, order: this.pageable.order},
        this.searchForm
      );
    },

    simpleSearch(keyword) {
      this.searchForm.keyword = keyword;
      this.searchForm.type = null;
      this.searchForm.scoreType = null;
      this.searchForm.userDeptRoleId = null;
      this.searchForm.rankingReasonId = null;
      this.doSearch();
    },

    advanceSearch(event) {
      let advanceSearchForm = event.advanceSearchForm;
      this.searchForm.keyword = null;
      this.searchForm.type = advanceSearchForm.type;
      this.searchForm.scoreType = advanceSearchForm.scoreType;
      this.searchForm.userDeptRoleId = advanceSearchForm.userDeptRoleId;
      this.searchForm.rankingReasonId = advanceSearchForm.rankingReasonId;
      this.searchForm.fromDate = advanceSearchForm.fromDate;
      this.searchForm.toDate = advanceSearchForm.toDate;
      this.initDateRange();
      this.doSearch();
    },

    doSort(sort) {
      this.pageable.sort = sort;
      this.pageable.order =
        sort === this.pageable.sort
          ? this.pageable.order === "asc"
          ? "desc"
          : "asc"
          : "asc";
      this.doSearch();
    },

    doSearch() {
      //store query params at location-url
      this.$router.replace({
        name: this.$router.name,
        params: this.$route.params,
        query: this.buildQuery()
      });

      this.items = [];
      this.pageable.page = 0;

      this.$nextTick(
        () =>
          this.$refs.infiniteLoading &&
          this.$refs.infiniteLoading.stateChanger.reset()
      );
    },

    infiniteHandler($state) {
      this.list().then(items => {
        this.pageable.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
    },

    list() {
      let pageable = utils.convertPageableToSubmit(this.pageable);
      return rankingScoreViewService
        .findAll(this.searchForm, pageable)
        .then(response => {
          let items = response.data;
          items && this.items.push(...items);
          return items;
        });
    }
  }
};
</script>

<style scoped>
.leftSection {
  width: auto !important;
}
@media only screen and (min-width: 12in) and (max-width: 16in) {
  .theTitle__lv3 {
    width: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ranking-score/ranking-score-index.vue